// extracted by mini-css-extract-plugin
module.exports = {"switchIcon":"components-base-Svg-Icons-SwitchIcon-SwitchIcon__switchIcon--3ECzo"};